module.exports = __webpack_public_path__ + "static/media/6.955a347.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/majors/6.wav
// module id = CGau
// module chunks = 0